const isArray = (item: unknown) => Array.isArray(item);
const isNull = (item: unknown) => item === null;
const isObject = (item: unknown) => typeof item === 'object' && !isArray(item) && !isNull(item);

function c(a = [], b = []) {
  const temp = [...a];

  b.forEach((i) => {
    if (isArray(i)) {
      temp.push(c([...i]));
      return;
    }

    if (isObject(i)) {
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      temp.push(extend({}, i));
      return;
    }

    return temp.push(i);
  });

  return temp;
}

export default function extend(a = {}, b = {}) {
  const temp = { ...a };
  for (const key of Object.getOwnPropertyNames(b)) {
    if (isObject(b[key])) {
      temp[key] = extend(temp[key], b[key]);
    } else if (isArray(b[key])) {
      temp[key] = c(b[key]);
    } else {
      temp[key] = b[key];
    }
  }

  return temp;
}
